import React from 'react';
import cx from 'classnames';
import AvatarLoading from '../../../ui-elements/Avatar/AvatarLoading';
import Loading from '../../../ui-elements/Loading/Loading';

/**
 * CompanyTitleLoading Component
 * 
 * A skeleton/loading state component that displays placeholder animations
 * while company data is being fetched. This matches the structure of the
 * CompanyTitle component but only shows loading indicators.
 */
const CompanyTitleLoadingSkeleton: React.FC = () => {
    // Define the field titles that will be displayed with loading indicators
    // This matches the structure of the actual CompanyTitle component
    const fieldTitles = [
        'Fyrirtæki',      // Company name
        'Kennitala',      // ID number
        'Póstfang',       // Address
        'Símanúmer',      // Phone number
        'Ísat',           // ISAT code
        'Ísat flokkur',   // ISAT category
        'Forráðamaður',   // Company representative
        'Skráð',          // Registration date
    ];

    return (
        <div className={cx('KCL_company-title')}>
            {fieldTitles.map((title, idx) => (
                <div key={idx} className="info-col">
                    {/* Show avatar loading animation only for the first field (Fyrirtæki/Company) */}
                    {title === 'Fyrirtæki' && <AvatarLoading size="lg" />}

                    <div className="info-item">
                        {/* Display the field title */}
                        <span className="title">{title}</span>

                        {/* Display a loading skeleton for the value */}
                        <span
                            className={cx('value', {
                                // Apply specific styling classes to match the real component
                                isatCategory: title === 'Ísat flokkur' || title === 'Forráðamaður',
                                companyName: title === 'Fyrirtæki',
                            })}
                        >
                            {/* Show a loading bar with width 120 */}
                            <Loading width="120" count={1} />
                        </span>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default React.memo(CompanyTitleLoadingSkeleton);